import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React, { useLayoutEffect } from 'react';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
// import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { IconButton } from 'src/components';
// import { DashboardStackParams } from 'src/navigations/AppNavigationProps';
import { pixelScaler } from 'src/themes/Metrics';
import { TripDetailModal } from '../../components/layout/TripDetailModal';

const PassengerInfoView = React.lazy(() => import('./PassengerInfoView'));

const PassengerInfoScreen = (props: any) => {
  // const { t } = useTranslation();
  const navigation = useNavigation();
  const { returnTripInfo, departureTripInfo, passengerInfo } = useTripInfoState();

  console.log({ returnTripInfo, departureTripInfo, passengerInfo });
  const [isVisible, setVisible] = React.useState(false);
  // const { params } = useRoute<RouteProp<DashboardStackParams, 'SelectSeatScreen'>>();

  useLayoutEffect(() => {
    const selectSeatHeaderRight = () => (
      <IconButton
        icon={<Ionicons name="information-circle-outline" size={pixelScaler(24)} color="white" />}
        onPress={() => {
          setVisible(true);
        }}
      />
    );

    navigation.setOptions({
      headerRight: selectSeatHeaderRight,
    });
  }, []);

  return (
    <React.Suspense>
      <PassengerInfoView {...props} />
      {isVisible && (
        <TripDetailModal
          isVisible={isVisible}
          onClose={() => setVisible(false)}
          returnTripId={returnTripInfo?.tripId}
          departureTripId={departureTripInfo?.tripId}
        />
      )}
    </React.Suspense>
  );
};

export default PassengerInfoScreen;
